import { nonNullable } from '@wix/wix-data-client-common-standalone'

export function assertNonNullable<Type>(
  value: Type,
): asserts value is NonNullable<Type> {
  if (!nonNullable(value)) {
    throw new Error('The value is nullable.')
  }
}
